import { ProductECourseItemErrorsType } from '../../../types/product-interface'

export const getCourseError = (errors: ProductECourseItemErrorsType) => !!errors['courseId']
